import { TableTranslations } from '@/assets/locales/components/table/table.translations.en';

export const tableTranslations: TableTranslations = {
  content: {
    button: {
      clear: 'Wyczyść',
      search: 'Wyszukaj',
      tour: 'Pomoc',
    },
    maxRows: 'Maksymalna liczba wierszy',
    nextPage: 'Następna strona',
    noResults: 'Brak wyników',
    of: 'z',
    previousPage: 'Poprzednia strona',
  },
};
